<template>
  <form class="form_content" @submit.prevent="submitForm">
    <h3>Enter your new password</h3>
    <InputCustom
      v-model.trim="password"
      :type="'password'"
      :className="{
        error: password && !isPasswordValid,
        required: isPasswordValid === false,
        valid: isPasswordValid,
      }"
      :placeholder="'Enter your password'"
      @input="validatePassword" 
    />
    <InputCustom
      v-model.trim="confirmPassword"
      :type="'password'"
      :className="{
        error: confirmPassword && !isConfirmPasswordValid,
        required: isConfirmPasswordValid === false,
        valid: isConfirmPasswordValid,
      }"
      :placeholder="'Confirm your password'"
      @input="validatePassword" 
    />
    <ButtonWithLoading
      title="Send"
      :isLoading="loading"
      type="submit"
      class="w-100"
    />
  </form>
</template>

<script>
import { DataService } from "../../../config/dataService";
import ButtonWithLoading from "../ButtonWithLoading.vue";
import InputCustom from "../InputCustom.vue";
export default {
  name: "RestorePasswordForm",
  data() {
    return {
      password: "",
      confirmPassword: "",
      isPasswordValid: false,
      isConfirmPasswordValid: false,
      loading: false,
    };
  },

  components: { InputCustom, ButtonWithLoading },

  methods: {
    closeModal() {
      this.$emit("cancel");
    },
    async submitForm() {
      if (!this.isPasswordValid) {
        this.$notifications.notify({
          message: `<span>Password must contains at least: 8 characters, 1 number, 1 lowercase and 1 uppercase letters and 1 special symbol</span>`,
          icon: "nc-icon nc-simple-remove",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
      } else if (!this.isConfirmPasswordValid){
        this.$notifications.notify({
          message: `<span>Passwords do not match</span>`,
          icon: "nc-icon nc-simple-remove",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
      }
      
      else {
      try {
        this.loading = true;
        const { key, email } = this.$route.query;
        await DataService.post("users/restore-password", {
          password: this.password,
          email,
          key,
        });
        this.closeModal();
        this.$notifications.notify({
          message: `<span>Password change</span>`,
          icon: "nc-icon nc-check-2",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "success",
        });
      } catch (error) {
        this.$notifications.notify({
          message: `<span>${error.response.data.errorDescription}</span>`,
          icon: "nc-icon nc-simple-remove",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
      } finally {
        this.loading = false;
      }
    }
    },
    validatePassword() {
      const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z\W]{8,}$/;
      this.isPasswordValid = passwordRegex.test(this.password);
    },
    validatePasswordMatch() {
      this.isConfirmPasswordValid =
      this.confirmPassword === this.password && this.confirmPassword !== "" && this.isPasswordValid;
    },
  },
  
  computed: {
    valid() {
      return this.isPasswordValid && this.isConfirmPasswordValid;
    },
  },
  watch: {
    password() {
      this.validatePassword();
    },
    confirmPassword() {
      this.validatePasswordMatch();
    },
  },
};
</script>

<style scoped lang="scss"></style>
